import { useQuery } from 'react-query';

import { axios } from 'lib';

const getExclusions = (resource, id, lotId) => {
  return axios.get(`/api/${resource}/${id}/setup/lots/${lotId}/exclusions`);
};

export const useExclusions = (resource, id, lotId, options = {}) => {
  return useQuery(
    `${resource}-${id}-setup-lots-${lotId}-exclusions`,
    () => getExclusions(resource, id, lotId),
    {
      //@ts-ignore
      initialData: { data: { data: [] } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
